// SpinnerButton.tsx
import React from 'react'
import { SpinnerButtonProps } from '../interfaces/appInterface'
import Loading from './Loading'

const SpinnerButton: React.FC<SpinnerButtonProps> = ({
  isLoading = false,
  onClick,
  buttonText,
  disabled = false,
  className = '',
  loaderText = 'Loading...',
  type,
  children
}) => {
  let spinnerColor = '#fff'
  if (className.includes('btn-outline-warning')) {
    spinnerColor = '#ffc107'
  } else if (className.includes('btn-outline-')) {
    const match = className.match(/btn-outline-(\w+)/)
    if (match) {
      const colorMap: Record<string, string> = {
        primary: '#1C743B',
        secondary: '#6c757d',
        success: '#198754',
        danger: '#dc3545',
        info: '#0dcaf0',
        dark: '#212529',
        light: '#f8f9fa'
      }
      spinnerColor = colorMap[match[1]] || '#fff'
    }
  } else if (!className.includes('btn-')) {
    spinnerColor = '#1C743B'
  }

  return (
    <button
      className={`${className} position-relative`}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
    >
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loading
            size="sm"
            color={spinnerColor}
            center={false} // Disable centering since button already handles it.
          />
          {loaderText && loaderText !== 'Loading...' && (
            <span className="ms-2">{loaderText}</span>
          )}
        </div>
      ) : children ? (
        children
      ) : (
        buttonText
      )}
    </button>
  )
}

export default SpinnerButton
